import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back!");
      nav(loc.state?.from || "/browse", { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-5 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#E8E5F0] p-8 sm:p-10 fade-in-up">
        <h1 className="font-display text-3xl tracking-tight font-medium">Welcome back</h1>
        <p className="text-[#6B7280] mt-2">Log in to post and claim curb items.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required className="mt-1.5 h-11 rounded-xl" data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              required className="mt-1.5 h-11 rounded-xl" data-testid="login-password" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading}
            className="w-full h-11 rounded-full bg-[#7C3AED] hover:bg-[#5B21B6] text-white"
            data-testid="login-submit">
            {loading ? "Logging in…" : "Log in"}
          </Button>
        </form>
        <p className="text-sm text-[#6B7280] mt-6 text-center">
          New here? <Link to="/register" className="text-[#7C3AED] hover:underline" data-testid="login-register-link">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
